import React from "react";
import { useCruise } from "../context/CruiseContext";
import { Button } from "./ui/button";
import { Check, CreditCard, Users, CalendarClock, Phone } from "lucide-react";

const CTASection = () => {
  const { EVENT, SHIP_IMAGE, PAYMENT } = useCruise();
  const payoffPassed = new Date(`${PAYMENT.payoffDate}T23:59:59`) < new Date();
  const perks = [
    { icon: CreditCard, label: `Deposits as low as ${EVENT.depositFrom} per person` },
    { icon: CalendarClock, label: payoffPassed ? `Full payment required \u2013 call ${EVENT.phone}` : `EZ monthly plan \u2013 payoff by ${EVENT.finalPayoff}` },
    { icon: Users, label: "Group rates & easy booking" },
  ];
  return (
    <section id="book" className="relative py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img src={SHIP_IMAGE} alt={`${EVENT.ship} cruise ship`} className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0A] via-[#0A0A0A]/90 to-[#0A0A0A]/50" />
      </div>

      <div className="relative max-w-7xl mx-auto px-5">
        <div className="max-w-2xl">
          <span className="inline-block bg-[var(--hh-gold)] text-[#0A0A0A] font-cond uppercase text-xs font-bold tracking-widest px-3 py-1 mb-5">
            {EVENT.badge}
          </span>
          <h2 className="font-display uppercase text-white text-4xl sm:text-6xl leading-[0.95]">
            Secure Your <span className="text-[#E50914]">Cabin</span> Today!
          </h2>
          <p className="mt-5 text-white/70 text-lg">
            Cabins sell out fast. Lock in your spot aboard the {EVENT.ship} for {EVENT.duration.toLowerCase()}
            {" "}of pure house-music paradise.
          </p>

          <ul className="mt-8 space-y-4">
            {perks.map((p) => (
              <li key={p.label} className="flex items-center gap-3">
                <span className="flex items-center justify-center w-9 h-9 rounded-full bg-[#1B8A5A] text-white shrink-0">
                  <Check size={18} />
                </span>
                <span className="font-cond uppercase tracking-wide text-white text-base">{p.label}</span>
              </li>
            ))}
          </ul>

          <div className="mt-10 flex flex-wrap gap-4">
            <a href={EVENT.bookingUrl} target="_blank" rel="noopener noreferrer">
              <Button className="bg-[#E50914] hover:bg-[#c20710] text-white font-cond uppercase tracking-widest text-base rounded-full px-10 py-6 h-auto">
                Book Now
              </Button>
            </a>
            <a href={EVENT.phoneHref}>
              <Button
                variant="outline"
                className="border-white/40 bg-transparent text-white hover:bg-white hover:text-[#0A0A0A] font-cond uppercase tracking-widest text-base rounded-full px-8 py-6 h-auto"
              >
                <Phone size={18} className="mr-2" /> {EVENT.phone}
              </Button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
